import React from "react";
import { MessageSquareMore, Image as ImageIcon, Star, BarChart3, CalendarHeart, Gift, User, CreditCard, Settings, HelpCircle, LogOut, Home } from "lucide-react";
import { useSite } from "../context/SiteContext";

const MAIN = [
  { id: "chat", label: "Chat with Maya", icon: MessageSquareMore },
  { id: "from-me", label: "From Me", icon: ImageIcon, heart: true },
  { id: "for-you", label: "For You", icon: Star },
  { id: "choose", label: "Choose for Me", icon: BarChart3 },
  { id: "updates", label: "My Updates", icon: CalendarHeart },
];
const ACCOUNT = [
  { id: "profile", label: "My Profile", icon: User },
  { id: "subscription", label: "Manage Subscription", icon: CreditCard },
  { id: "settings", label: "Settings", icon: Settings },
  { id: "help", label: "Help & Support", icon: HelpCircle },
];

const Item = ({ it, active, go }) => (
  <button onClick={() => go(it.id)} data-testid={`mem-nav-${it.id}`} className={`mem-nav ${active ? "mem-nav-active" : ""}`}>
    <it.icon className="w-[21px] h-[21px]" strokeWidth={1.8} />
    <span>{it.label}</span>
    {it.heart && <span className="text-[#e8365f] text-[17px] leading-none">♥</span>}
    {it.gift && <Gift className="w-4 h-4 text-[#e8365f]" fill="#f7b2c2" />}
  </button>
);

export default function Sidebar({ active, go, onLogout }) {
  const { img } = useSite();
  return (
    <aside className="mem-sidebar hidden lg:flex flex-col">
      <button onClick={() => go("chat")} className="text-left px-6 pt-6" data-testid="mem-logo">
        <p className="mem-brand text-[34px] leading-none">Silky Maya <span className="text-[#e8365f]">♥</span></p>
        <p className="text-[15px] text-[#4a3d40] mt-2">Our private space</p>
      </button>
      <nav className="mt-6 px-3 space-y-1">{MAIN.map((it) => <Item key={it.id} it={it} active={active === it.id} go={go} />)}</nav>
      <div className="mx-6 my-5 border-t border-[#efdcdc]" />
      <nav className="px-3 space-y-1">
        {ACCOUNT.map((it) => <Item key={it.id} it={it} active={active === it.id} go={go} />)}
        <button onClick={onLogout} className="mem-nav" data-testid="mem-logout"><LogOut className="w-[21px] h-[21px]" strokeWidth={1.8} /><span>Log Out</span></button>
      </nav>
      <div className="mt-auto px-5 pb-6 pt-6">
        <div className="mem-polaroid">
          <img src={img("about", "/img/about.jpg") || img("hero")} alt="Maya" />
          <p className="mem-hand text-[26px] leading-[1.0] mt-2 pl-1">Thank you for<br />being here <span className="text-[#e8365f] font-sans text-[20px]">♥</span><br /><span className="pl-12">- Maya</span></p>
        </div>
      </div>
    </aside>
  );
}

const MOB = [
  { id: "home", label: "Home", icon: Home },
  { id: "chat", label: "Chat", icon: MessageSquareMore },
  { id: "from-me", label: "From Me", icon: ImageIcon },
  { id: "for-you", label: "For You", icon: Star },
  { id: "profile", label: "Profile", icon: User },
];

export function MobileNav({ active, go }) {
  return (
    <nav className="lg:hidden mem-bottom-nav">
      {MOB.map((m) => (
        <button key={m.id} onClick={() => (m.id === "home" ? (window.location.href = "/") : go(m.id))} data-testid={`mem-mob-${m.id}`}
          className={`flex flex-col items-center gap-1 text-[11px] ${active === m.id ? "text-[#e8365f]" : "text-[#6b5d60]"}`}>
          <m.icon className="w-[22px] h-[22px]" strokeWidth={1.8} fill={active === m.id ? "#f9c9d4" : "none"} />
          {m.label}
        </button>
      ))}
    </nav>
  );
}
